import { makeStyles } from "@material-ui/core/styles";
import {
  PrimaryColor,
  White,
  LightPrimaryColor,
  Black,
  DarkGrey,
} from "../../shared/styles/colors";

export default makeStyles(() => ({
  containerRow: {
    display: "grid",
    gap: "10px",
    width: "100% !important",
    height: "80vh",
    padding: "10px 40px 0px 40px",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    "@media (max-width: 640px)": {
      alignItems: "center",
      justifyContent: "center",
      marginTop: "15px",
      gap: "0px",
      padding: "0px 0px 0px 0px",
      height: "auto",
    },
  },
  containerCol: {
    display: "grid",
    gap: "10px",
    width: "50% !important",
    height: "auto",
    marginLeft: "10%",
    padding: "10px 40px 0px 40px",
    gridTemplateRows: "repeat(auto-fit, minmax(250px, 1fr))",
    "@media (max-width: 640px)": {
      alignItems: "center",
      justifyContent: "center",
      marginTop: "15px",
      gap: "0px",
      padding: "0px 0px 0px 0px",
      height: "auto",
    },
  },
  addItemGrid: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "100% !important",
    height: "280px",
    border: "2px dashed #999999",
    borderRadius: "5.85px",
    background: "#faf9f9",
    fontSize: "2rem",
    color: "#999999",
    "@media (max-width: 640px)": {
      height: "200px",
      marginBottom: "15px",
    },
  },
  itemGrid: {
    display: "flex",
    flexDirection: "column",
    width: "100% !important",
    height: "280px",
    border: "1px solid #999999",
    borderRadius: "5.85px",
    padding: "10px",
    cursor: "pointer",
    "@media (max-width: 640px)": {
      height: "auto",
      marginBottom: "15px",
    },
    "&:hover": {
      background: "#f0f0f0",
    },
  },
  itemHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  img: {
    width: "40px",
  },
  priceText: {
    color: PrimaryColor,
    fontSize: "1.3rem",
    fontWeight: 600,
  },
  itemBody: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    width: "100%",
    marginTop: "10px",
  },
  description: {
    width: "100%",
    fontSize: "1rem",
    textAlign: "start",
    display: "block",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    "@media (max-width: 640px)": {
      width: "100%",
    },
  },
  icon: {
    width: "20px",
  },
  time: {
    fontSize: ".8rem",
  },
  button: {
    padding: "0.5rem",
    margin: "0.5rem",
    width: "12rem",
    color: White,
    background: PrimaryColor,
    borderRadius: "10px",
    textTransform: "none",
    "&:hover": {
      background: LightPrimaryColor,
    },
    "&:disabled": {
      color: "grey",
      cursor: "none",
    },
    "@media (max-width: 640px)": {
      width: "auto",
      marginTop: "10%",
    },
  },
  takenDiv: {
    display: "flex",
    flexDirection: "column",
    width: "100% !important",
    height: "280px",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid #999999",
    borderRadius: "5.85px",
    padding: "10px",
    background: "#faf9f9",
    zIndex: 1,
    "@media (max-width: 640px)": {
      width: "90%",
      height: "auto",
      marginBottom: "15px",
    },
  },
  takenSubDiv: {
    display: "flex",
    flexDirection: "column",
    width: "100% !important",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "40px",
  },
  takenTitle: {
    color: "#333333",
    fontSize: "1.2rem",
    fontWeight: 600,
    wordWrap: "break-word",
    marginBottom: "10px",
  },
  // Modal
  headerDiv: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    "@media (max-width: 640px)": {
      alignItems: "center",
      justifyContent: "start",
      flexDirection: "column",
    },
  },
  headerSubDiv: {
    display: "flex",
    flexDirection: "row",
    width: "8rem",
    alignItems: "center",
    justifyContent: "space-between",
    "@media (max-width: 640px)": {
      width: "100%",
      flexDirection: "column",
      alignItems: "start",
      justifyContent: "space-between",
    },
  },
  headerSubDiv2: {
    display: "flex",
    flexDirection: "row",
    width: "auto",
    alignItems: "center",
    justifyContent: "start",
    "@media (max-width: 640px)": {
      width: "100%",
      flexDirection: "column",
      alignItems: "start",
      justifyContent: "start",
    },
  },
  headerSubDiv3: {
    display: "flex",
    flexDirection: "row",
    width: "auto",
    alignItems: "center",
    justifyContent: "space-between",
    "@media (max-width: 640px)": {
      width: "100%",
      flexDirection: "column",
      alignItems: "start",
      justifyContent: "space-between",
    },
  },
  title: {
    width: "100%",
    color: Black,
    fontSize: "1.2rem",
    fontWeight: "700",
    textAlign: "start",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    "@media (max-width: 640px)": {
      fontSize: "1.1rem",
      marginBottom: "0.5rem",
    },
  },
  subtitle: {
    color: DarkGrey,
    fontSize: "1rem",
  },
  form: {
    marginTop: "0%",
  },
  label: {
    fontWeight: "600",
  },
  inputContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100% !important",
    marginTop: "1.5rem",
  },
  inputGroup: {
    display: "flex",
    flexDirection: "row",
    width: "98% !important",
    alignItems: "center",
    padding: 0,
    "@media (max-width: 640px)": {
      flexDirection: "column",
      width: "100% !important",
    },
  },
  input: {
    width: "95% !important",
    borderRadius: "5px",
    padding: "0.5rem",
    margin: "0.5rem",
    border: ".5px solid #7E7D7D",
    background: White,
    color: Black,
    "@media (max-width: 640px)": {
      width: "100% !important",
    },
    "& div, input, button": {
      //child
      border: "none",
    },
  },
  textarea: {
    width: "95% !important",
    height: "5rem",
    maxHeight: "18rem",
    borderRadius: "5px",
    padding: "0.5rem",
    margin: "0.5rem",
    border: ".5px solid #7E7D7D",
    background: White,
    color: Black,
    "@media (max-width: 640px)": {
      width: "100% !important",
      maxHeight: "6rem",
    },
  },
  buttonDiv: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "100% !important",
  },
  image: {
    width: "30px",
    height: "30px",
    cursor: "pointer",
  },
  uploadInput: {
    display: "flex",
    flexDirection: "column",
    width: "98%",
    height: "8rem",
    border: "1px dashed #999999",
    borderRadius: "8px",
    alignItems: "center",
    justifyContent: "center",
    "@media (max-width: 640px)": {
      height: "8rem",
    },
  },
  button2: {
    padding: "0.5rem",
    margin: "0.5rem",
    width: "8rem !important",
    color: White,
    background: PrimaryColor,
    borderRadius: "10px",
    textTransform: "none",
    "&:hover": {
      background: LightPrimaryColor,
    },
    "&:disabled": {
      color: "grey",
      cursor: "none",
    },
    "@media (max-width: 640px)": {
      width: "auto",
      marginTop: "10%",
    },
  },
  button3: {
    padding: "0.5rem",
    margin: "0.5rem",
    width: "8rem !important",
    color: PrimaryColor,
    background: White,
    borderRadius: "10px",
    border: "1px solid #1e2e55",
    textTransform: "none",
    "&:hover": {
      background: LightPrimaryColor,
      color: White,
      border: "1px solid #1e2e5580",
    },
    "@media (max-width: 640px)": {
      width: "auto",
      marginTop: "10%",
    },
  },
  textDiv: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    marginTop: "1rem",
    alignItems: "center",
    justifyContent: "start",
  },
  label2: {
    color: "#757575",
    fontSize: "14px",
    fontWeight: 400,
    wordWrap: "break-word",
    width: "25%",
  },
  text: {
    color: "#333333",
    fontSize: "14px",
    fontWeight: 600,
    wordWrap: "break-word",
    width: "70%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "wrap",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "1rem",
    "& th, & td": {
      padding: "8px",
      fontSize: "14px",
      wordWrap: "break-word",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "wrap",
    },
    "& th": {
      textAlign: "left",
    },
  },
  tableHeader: {
    fontWeight: "bold",
    textAlign: "left",
    padding: 1,
  },
  rightDiv: {
    display: "flex",
    flexDirection: "column",
    width: "50%",
    alignItems: "start",
    justifyContent: "start",
    "@media (max-width: 640px)": {
      width: "100%",
    },
  },
  leftDiv: {
    display: "flex",
    flexDirection: "column",
    width: "50%",
    maxHeight: "40rem",
    alignItems: "start",
    justifyContent: "start",
    overflow: "auto",
    "@media (max-width: 640px)": {
      width: "100%",
      maxHeight: "100%",
      overflow: "hidden",
      marginTop: "2rem",
    },
  },
  detailsDiv: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "start",
    justifyContent: "space-between",
    marginTop: "2rem",
    "@media (max-width: 640px)": {
      width: "100%",
      flexDirection: "column",
    },
  },
  uploadContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: "2rem",
    "@media (max-width: 640px)": {
      width: "100%",
      flexDirection: "column",
    },
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    "@media (max-width: 640px)": {
      width: "100%",
      flexDirection: "column",
      alignItems: "start",
      justifyContent: "start",
    },
  },
  form2: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    marginTop: "20px",
    alignItems: "start",
    justifyContent: "center",
  },
  input2: {
    width: "100% !important",
    borderRadius: "5px",
    padding: "0.5rem",
    margin: "0.5rem",
    border: ".5px solid #7E7D7D",
    background: White,
    color: Black,
  },
  form3: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
}));
